import React, { Component } from "react";
import { getMisc } from "../../../../localstorage-service";
import { Modal, Button } from "react-bootstrap";

class AssessmentModal extends Component {
  render() {
    return (
      <Modal show={this.props.showAssessment} className="assessment-modal">
        <Modal.Header>
          <Modal.Title>
            {this.props.title} - {getMisc("assessmenttitle")}
            {(this.props.isAssessmentSubmitted || !this.props.startAssessment) && (
              <div className="pull-right">
                <Button onClick={this.props.handleClose}>{getMisc("backlearning")}</Button>
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.modalBodyHtml}</Modal.Body>
        {(this.props.isAssessmentSubmitted || !this.props.startAssessment) && (
          <Modal.Footer>
            <Button onClick={this.props.handleClose}>{getMisc("close")}</Button>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

export default AssessmentModal;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/AssessmentModal.js